import { FC, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Modal } from '../../../ui'
import { Alert, Typography } from 'antd'
import { ButtonsBlock } from '../../../Edit/components'
import {currencyFormat, signBody} from '../../../helpers'
import { issueCertificate } from '../../config'
import useRequest from '../../../hooks/useRequest'
import style from './style.m.less'
import moment from 'moment'
import capitalize from 'lodash/capitalize'
import { useTranslation } from 'react-i18next'

interface IApproveModal {
    isModalVisible: boolean
    setIsModalVisible: (value: boolean) => void
    setDisableSend: (value: boolean) => void
    data: any
    userData: any
    isSignExpired: boolean
    isEmptyAttorney: boolean
    isAttorneyExpired: boolean
}

const ApproveModal: FC<IApproveModal> = ({ isModalVisible, setIsModalVisible, setDisableSend, data, userData, isSignExpired, isEmptyAttorney, isAttorneyExpired }) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [disableCondition, setDisableCondition] = useState(false)
    const { fetch } = useRequest(issueCertificate)

    const { generator, account_id, period, volume, rate, balance } = data
    const dateArr = period ? period.split(',') : []

    const handleOk = () => {
        setIsModalVisible(false)
    }

    const onSuccess = ({
                           certificate_id,
                           certificate_number,
                       }: {
        certificate_id: string
        certificate_number: string
    }) => {
        navigate(`/user-certificate-card/${certificate_number}`, {
            state: {
                toolType: 'Сертификаты происхождения',
                cardLabel: 'Сертификат происхождения',
                isUserType: true,
                id: certificate_id,
                isIssuedCert: true,
                isOwner: true,
            },
        })
        setIsModalVisible(false)
    }

    const confirmAgreement = async () => {
        setDisableSend(true)
        setDisableCondition(true)
        const body = {
            generator_id: generator?.generator_id,
            account_id: account_id,
            month: Number(dateArr[0]),
            year: Number(dateArr[1]),
            capacity: Number(volume),
        }
        const { request_id, signature } = await signBody(body, userData)

        fetch({
            body,
            getParams: {
                request_id,
            },
            config: {
                headers: {
                    Signature: signature,
                },
            },
            successMessage: {
                title: 'Успешно',
                description: 'Сертификат происхождения выпущен',
            },
            onSuccess,
            errorCodeMessage: true,
        })
    }

    return (
        <Modal isModalVisible={isModalVisible} bodyStyle={{ width: '600px' }}>
            <div className={style.modalWrapper}>
                <div className={style.headerWrapper}>
                    <div className={style.header}>Подтверждение выпуска сертификата</div>
                </div>
            </div>
            <Alert
                message={
                    <>
                        <div>
                            ГО: <Typography.Text strong>{generator?.name}</Typography.Text>
                        </div>
                        <div>
                            Период производства АГ: <Typography.Text strong>{period ? capitalize(moment(dateArr[3]).format('MMMM, YYYY')) : ''}</Typography.Text>
                        </div>
                        <div style={{marginTop: '16px'}}>
                            Номинал, кВт*ч: {currencyFormat(volume)}
                        </div>
                        <div style={{marginTop: '16px'}}>
                            {period
                                ? `Срок действия АГ будет завершен ${moment(dateArr[2],).format('DD.MM.YYYY')}`
                                : ''
                            }
                        </div>
                    </>
                }
                className={style.infoAlert}
                type="info"
                showIcon
            />
            <Alert
                className={style.modalAlert}
                message={
                    <div className={style.modalAlertText}>
                        <div>
                            За операцию взымается оплата в размере{' '}
                            <Typography.Text strong>{rate}</Typography.Text>
                        </div>
                        <div>Баланс платежного счета: {balance}</div>
                    </div>
                }
                type="warning"
                showIcon
            />
            {isSignExpired && (
                <Alert
                    className={style.signError}
                    message={'Истек срок действия ЭП'}
                    type="error"
                    showIcon
                />
            )}
            {(isEmptyAttorney || isAttorneyExpired) && (
                <Alert
                    className={style.signError}
                    message={isEmptyAttorney ? t('profile.attorneyIsMissing') : t('profile.attorneyIsExpired')}
                    type="error"
                    showIcon
                />
            )}
            <div className={style.buttonsBlock}>
                <ButtonsBlock
                    confirmAction={confirmAgreement}
                    cancelAction={handleOk}
                    disableCondition={disableCondition}
                    confirmTitle="Подписать и выпустить"
                    confirmDisabled={isSignExpired || isEmptyAttorney || isAttorneyExpired}
                />
            </div>
        </Modal>
    )
}

export default ApproveModal
